;
define("store_locator_tooltip.tpl", function(){});

